import React from "react";
import { waUrl } from "../lib/constants";

export const SessionCard = ({
    eyebrow,
    title,
    subhead,
    testId,
    message,
    cta = "Reserve →",
}) => {
    const href = waUrl(
        message || `Hi, I'd like to reserve a session: ${title}`,
    );
    return (
        <article
            className="rs-card"
            data-testid={testId || "session-card"}
            style={{
                backgroundColor: "#0a0a0a",
                borderTop: "1px solid #c9a227",
                borderRight: "1px solid rgba(201,162,39,0.08)",
                borderBottom: "1px solid rgba(201,162,39,0.08)",
                borderLeft: "1px solid rgba(201,162,39,0.08)",
                padding: "32px 26px 28px",
                display: "flex",
                flexDirection: "column",
                gap: 12,
                minHeight: 280,
                height: "100%",
            }}
        >
            {eyebrow && (
                <p
                    style={{
                        color: "#c9a227",
                        fontSize: 10,
                        letterSpacing: "0.32em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                        margin: 0,
                    }}
                >
                    {eyebrow}
                </p>
            )}
            <h3
                className="font-serif"
                style={{
                    color: "#ffffff",
                    fontSize: 20,
                    lineHeight: 1.25,
                    fontWeight: 500,
                    letterSpacing: "-0.01em",
                    marginTop: eyebrow ? 4 : 0,
                }}
            >
                {title}
            </h3>
            <p
                style={{
                    color: "#888888",
                    fontSize: 14,
                    lineHeight: 1.65,
                    flex: 1,
                    margin: 0,
                }}
            >
                {subhead}
            </p>
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testId || "session-card"}-reserve-btn`}
                style={{
                    color: "#c9a227",
                    fontSize: 11,
                    letterSpacing: "0.3em",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    fontWeight: 500,
                    alignSelf: "flex-start",
                    paddingTop: 6,
                    borderBottom: "1px solid transparent",
                    transition: "border-color 0.3s ease",
                }}
                onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#c9a227")
                }
                onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "transparent")
                }
            >
                {cta}
            </a>
        </article>
    );
};

export default SessionCard;
